import React, { useEffect } from 'react';
import { withContainer } from 'core/cache';

import { Loading } from 'uikit/loaders';

import getGroupsTransform from '../helpers/getGroupsTransform';

import GroupsEligibleMembers from '../components/groupsEligibleMembers';

import styles from '../styles/groupsEligibleMembers.module.scss';

const GroupsEligibleMembersContainer = ({ eligibleMembers, type, emptyStateText }) => {
  // reset cache to empty on unmount
  useEffect(
    () => () => {
      eligibleMembers.set({});
    },
    [],
  );

  const { users } = eligibleMembers.data;

  const shouldShowEmptyState = !users?.length;

  return eligibleMembers.status === 'success' ? (
    <GroupsEligibleMembers
      members={users}
      type={type}
      emptyStateText={emptyStateText}
      shouldShowEmptyState={shouldShowEmptyState}
    />
  ) : (
    <Loading className={styles.loader} />
  );
};

export default withContainer(GroupsEligibleMembersContainer, {
  hasRouter: true,
  cache: {
    eligibleMembers: {
      initialData: {},
      url: '/api/admin/groups/:id/info_with_users',
      transform: ({ data }) => getGroupsTransform({ data }),
      getParams: ({ props }) => {
        if (props.groupId) {
          return { id: props.groupId };
        }
      },
    },
  },
});
